import {lazy} from 'react';

const Login = lazy(() => import('./Login'));

export default Login;
